import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Modal } from 'react-bootstrap';
import config from '../../config/config';
import RequestInfo from '../components/requestInfo/RequestInfo';
import CustomerContactInfo from '../components/customerContactInfo/CustomerContactInfo';
import ParticularOfVehicle from '../components/quotationCVComponent/particularOfVehicle/ParticularOfVehicle';
import ParticularOfMainDriver from '../components/quotationCVComponent/particularOfMainDriver/ParticularOfMainDriver';
import NcdEntitlementSumInsuredSection from '../components/quotationCVComponent/ncdEntitlementSumInsuredSection/NcdEntitlementSumInsuredSection';
import CoverageInformation from '../components/coverageInformation/CoverageInformation';
import CoverageTypeInfo from '../components/quotationCVComponent/coverageTypeInfo/CoverageTypeInfo';
import QuoteSummary from '../components/quoteSummary/QuoteSummary';
import UnderwritingQuestion from '../components/quotationCVComponent/underwritingQuestion/UnderwritingQuestion';
import ProgressBar from '../components/progressBar/ProgressBar';
import { todayMomentISOString, quotationTodayAdd1Year, momentToISOString, quotationMomentAdd1Year, momentSetHKTimezone } from '../../utils/dateUtils';
import { numValidator } from '../utils/validator';

const moment = require('moment');
const async = require('async');

const appUrlPath = `/${config.appUrlPath}`;

/* eslint no-underscore-dangle: ["error", { "allow": ["_isAMomentObject"] }] */
export class CVForm extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
    const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';

    this.state = {
      redirect: false,
      option: [],
      count: 0,
      role,
      errorMsg: [],
      showModal: false,
      isLoading: false,
      validSubmit: true,
      mainDriverValidSubmit: true,
      additionalDriverValidSubmit: true,
      isValidCreateDriver: false,
      cv: {
        requestInfo: {
          agentCode,
          agentName,
          proposerType: 'Individual',
          quotationNo: '',
          insuredName: '',
          quotationDate: todayMomentISOString(),
          id: ''
        },
        custContactInfo: {
          contactPerson: '',
          proposerType: 'Individual',
          address: '',
          postalCode: '',
          country: 'HONG KONG',
          homeTel: '',
          officeTel: '',
          mobile: '',
          fax: '',
          email: ''
        },
        particularOfVehicle: {
          make: '',
          model: '',
          vehicleGroup: '',
          seatingCap: '',
          yearOfManufacture: '',
          vehicleRegNo: '',
          carryingGoods: false,
          bodyType: '',
          usage: 'commercialUseNoRental',
          tonnage: '',
          engineNo: '',
          chassisNo: '',
          busType: '',
          description: ''
        },
        particularOfMainDriver: {
          isDriverInfo: false,
          nameFormat: 'surnameGivenName',
          surname: '',
          givenName: '',
          drivingExperience: '',
          ageRange: '',
          maritalStatus: 'Single',
          sex: '',
          noOfClaimsInPast3Years: '',
          totalClaimAmountInPast3Years: '',
          occupation: '',
          nationality: 'HONG KONG',
          ncdEntitlement: '0',
          sumInsured: ''
        },
        particularOfAdditionalDriver: [

        ],
        coverageInfo: {
          coveragePeriodFrom: todayMomentISOString(),
          coveragePeriodTo: quotationTodayAdd1Year(),
          mainCoverType: {
            comprehensive: {
              checked: true,
              grossPremium: 0,
              netPremium: 0
            },
            thirdParty: {
              checked: false,
              grossPremium: 0,
              netPremium: 0
            }
          }
        },
        addOn: {
          carDamageInGuangdongProvinceOfChina: {
            checked: false,
            grossPremium: 0,
            netPremium: 0
          },
          thirdPartyLiabilityForTailgateOperation: {
            checked: false,
            grossPremium: 0,
            netPremium: 0
          },
          thirdPartyLiabilityForCraneOperation: {
            checked: false,
            grossPremium: 0,
            netPremium: 0
          },
          thirdPartyPropertyDamageLimit2M: {
            checked: false,
            grossPremium: 0,
            netPremium: 0
          },
          thirdPartyPropertyDamageLimit5M: {
            checked: false,
            grossPremium: 0,
            netPremium: 0
          },
          voluntaryExcessForThirdPartyPropertyDamage: {
            checked: false,
            grossPremium: 0,
            netPremium: 0
          },
          tailgate: {
            checked: false,
            grossPremium: 0,
            netPremium: 0,
            tailgateValue: ''
          },
          freezer: {
            checked: false,
            grossPremium: 0,
            netPremium: 0,
            freezerValue: ''
          },
          crane: {
            checked: false,
            grossPremium: 0,
            netPremium: 0,
            craneValue: ''
          }
        },
        underwritingQuestion: {
          q1: {
            checked: false,
            details: ''
          },
          q2: {
            checked: false,
            details: ''
          },
          q3: {
            checked: false,
            details: ''
          },
          q4: {
            checked: false,
            details: ''
          },
          q5: {
            checked: false,
            details: ''
          },
          q6: {
            checked: true,
            details: ''
          }
        },
        grossPremium: 0,
        netPremium: 0,
        mib: 0,
        levy: 0,
        premiumPayable: 0,
        caseStatus: 'pending',
        type: 'cv'
      }
    };

    this.handleChangeRequestInfo = this.handleChangeRequestInfo.bind(this);
    this.handleChangeCustContactInfo = this.handleChangeCustContactInfo.bind(this);
    this.handleChangeParticularOfVehicle = this.handleChangeParticularOfVehicle.bind(this);
    this.handleChangeParticularOfMainDriver = this.handleChangeParticularOfMainDriver.bind(this);
    this.handleChangeParticularOfAdditionalDriver = this.handleChangeParticularOfAdditionalDriver.bind(this);
    this.handleChangeCoverageInfoPreviousFrom = this.handleChangeCoverageInfoPreviousFrom.bind(this);
    this.handleChangeCoverageInfoPreviousTo = this.handleChangeCoverageInfoPreviousTo.bind(this);
    this.handleChangeMainCoverageType = this.handleChangeMainCoverageType.bind(this);
    this.handleChangeUnderwritingQuestion = this.handleChangeUnderwritingQuestion.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.optionChange = this.optionChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.createDriver = this.createDriver.bind(this);
    this.removeDriver = this.removeDriver.bind(this);
    this.close = this.close.bind(this);

    this.calculator = this.calculator.bind(this);
    this.calculationAmount = this.calculationAmount.bind(this);

    this.resetComprehensiveOrThirdParty = this.resetComprehensiveOrThirdParty.bind(this);
    this.handleSubmitType = this.handleSubmitType.bind(this)
    this.validationOnSubmit = this.validationOnSubmit.bind(this);
    this.validationMainDriverOccupationAndNationality = this.validationMainDriverOccupationAndNationality.bind(this);
    this.validationAdditionalDriverOccupationAndNationality = this.validationAdditionalDriverOccupationAndNationality.bind(this);
    this.validationOnCreateDriver = this.validationOnCreateDriver.bind(this);
  }

  componentWillMount() {
    // Check the access
    async.series([
      (callback) => {
        axios.get(`${appUrlPath}/getCsrfToken`, {
          params: {},
          headers: { 'ACTION-LOG': 'Access CV Form Page' }
        })
        .then((res) => {
          axios.defaults.headers.common = {
            'CSRF-TOKEN': res.data.csrfToken
          };
          callback();
        })
        .catch(() => {
          callback();
        });
      },
      (callback) => {
        this.setState({ isLoading: true })
        callback();
      },
      (callback) => {
        const quotationNo = window.location.search.substr(1).split('=')[1]
        if (!quotationNo) {
          if (this.props.location.state && this.props.location.state.isAgree) {
            axios.get(`${appUrlPath}/generateQuotationNoPV`, {
              params: {}
            })
            .then((res) => {
              const requestInfo = { ...this.state.cv.requestInfo };
              requestInfo.quotationNo = res.data.quotationNo;
              this.setState({ cv: { ...this.state.cv, requestInfo } }, () => {
                this.setState({ isLoading: false })
              });
            })
            .catch(() => {

            });
          } else {
            window.location = '/en/motorb2b/home';
          }
        } else {
          axios.get(`${appUrlPath}/getCVQuotationByNum`, {
            params: {
              quotationNo,
            }
          })
          .then((res) => {
            this.setState({ cv: res.data }, () => {
              this.optionChange();
              this.setState({ isLoading: false, count: res.data.particularOfAdditionalDriver.length });
              this.validationOnCreateDriver()
              this.validationOnSubmit(true)
            });
          })
          .catch(() => {

          });
        }
        callback();
      }
    ], () => {
    });
  }

  handleChangeRequestInfo(e) {
    if (e != null) {
      const requestInfo = { ...this.state.cv.requestInfo };
      if (e._isAMomentObject) {
        requestInfo.quotationDate = e.toDate();
      } else if (e.target.id === 'quotationNo') {
        requestInfo.quotationNo = e.target.value;
      } else if (e.target.id === 'idNo') {
        requestInfo.id = e.target.value;
      } else if (e.target.name === 'proposerType') {
        requestInfo.proposerType = e.target.value;
      } else if (e.target.id === 'insuredName') {
        requestInfo.insuredName = e.target.value;
      }
      this.setState({ cv: { ...this.state.cv, requestInfo } });
    }
  }

  handleChangeCustContactInfo(e) {
    const custContactInfo = { ...this.state.cv.custContactInfo };
    if (e.target.id === 'contactPerson') {
      custContactInfo.contactPerson = e.target.value;
    } else if (e.target.id === 'homeTel') {
      custContactInfo.homeTel = e.target.value;
    } else if (e.target.id === 'address') {
      custContactInfo.address = e.target.value;
    } else if (e.target.id === 'officeTel') {
      custContactInfo.officeTel = e.target.value;
    } else if (e.target.id === 'mobile') {
      custContactInfo.mobile = e.target.value;
    } else if (e.target.id === 'postalCode') {
      custContactInfo.postalCode = e.target.value;
    } else if (e.target.id === 'fax') {
      custContactInfo.fax = e.target.value;
    } else if (e.target.id === 'email') {
      custContactInfo.email = e.target.value;
    } else if (e.target.id === 'country') {
      custContactInfo.country = e.target.value;
    } else if (e.target.name === 'cusProposerType') {
      custContactInfo.proposerType = e.target.value;
    }

    this.setState({ cv: { ...this.state.cv, custContactInfo } });
  }

  handleChangeParticularOfVehicle(e) {
    const cv = { ...this.state.cv };
    const particularOfVehicle = cv.particularOfVehicle;
    const addOn = cv.addOn;

    let isMakeChange = false;
    let isModelChange = false;
    let isBusinessOccupationChange = false;
    if (e.target.id === 'make') {
      particularOfVehicle.make = e.target.value;
      particularOfVehicle.model = '';
      particularOfVehicle.vehicleGroup = '';
      isMakeChange = true;
    } else if (e.target.id === 'model') {
      particularOfVehicle.model = e.target.value;
      isModelChange = true;
    } else if (e.target.id === 'seatingCap') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.seatingCap = Number(e.target.value);
      }
    } else if (e.target.id === 'yearOfManufacture') {
      // if (/^\d{0,4}$/.test(e.target.value)) {
      if (numValidator(e.target.value)) {
        particularOfVehicle.yearOfManufacture = e.target.value;
      }
    } else if (e.target.id === 'vehicleRegNo') {
      particularOfVehicle.vehicleRegNo = e.target.value;
    } else if (e.target.name === 'carryingGoods') {
      particularOfVehicle.carryingGoods = e.target.checked;
    } else if (e.target.id === 'bodyType') {
      particularOfVehicle.bodyType = e.target.value;
    } else if (e.target.id === 'usage') {
      particularOfVehicle.usage = e.target.value;
    } else if (e.target.id === 'tonnage') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.tonnage = e.target.value;
        if (particularOfVehicle.tonnage != null) {
          addOn.thirdPartyPropertyDamageLimit2M.checked = false
          addOn.thirdPartyPropertyDamageLimit5M.checked = false
        }
      }
    } else if (e.target.id === 'businessOccupationType') {
      particularOfVehicle.busType = e.target.value;
      isBusinessOccupationChange = true;
    } else if (e.target.id === 'description') {
      particularOfVehicle.description = e.target.value;
    } else if (e.target.id === 'engineNo') {
      particularOfVehicle.engineNo = e.target.value;
    } else if (e.target.id === 'chassisNo') {
      particularOfVehicle.chassisNo = e.target.value;
    }

    this.setState({ cv }, () => {
      if (isMakeChange) { this.optionChange(); }
      if (isModelChange) { this.handleVehicleGroup(); }
      if (isBusinessOccupationChange) { this.validationOccupation(); }
    });
  }

  handleChangeParticularOfMainDriver(e) {
    const cv = { ...this.state.cv };
    const particularOfMainDriver = cv.particularOfMainDriver;
    let isOccupationChange = false;
    let isNationalityChange = false;
    let isAgeRangeChange = false;
    let isNcdChange = false;
    const addOn = cv.addOn;

    if (e.target.name === 'driverInfo') {
      particularOfMainDriver.isDriverInfo = e.target.checked
    } else if (e.target.name === 'nameFormat') {
      particularOfMainDriver.nameFormat = e.target.value;
    } else if (e.target.name === 'surname') {
      particularOfMainDriver.surname = e.target.value;
    } else if (e.target.name === 'givenName') {
      particularOfMainDriver.givenName = e.target.value;
    } else if (e.target.name === 'drivingExperience') {
      particularOfMainDriver.drivingExperience = e.target.value;
    } else if (e.target.name === 'ageRange') {
      particularOfMainDriver.ageRange = e.target.value;
      isAgeRangeChange = true;
    } else if (e.target.name === 'maritalStatus') {
      particularOfMainDriver.maritalStatus = e.target.value;
    } else if (e.target.name === 'sex') {
      particularOfMainDriver.sex = e.target.value;
    } else if (e.target.name === 'noOfClaimsInPast3Years') {
      particularOfMainDriver.noOfClaimsInPast3Years = Number(e.target.value);
    } else if (e.target.name === 'totalClaimAmountInPast3Years') {
      particularOfMainDriver.totalClaimAmountInPast3Years = Number(e.target.value);
    } else if (e.target.name === 'occupation') {
      particularOfMainDriver.occupation = e.target.value;
      isOccupationChange = true;
    } else if (e.target.name === 'nationality') {
      particularOfMainDriver.nationality = e.target.value;
      isNationalityChange = true;
    } else if (e.target.name === 'ncdEntitlement') {
      particularOfMainDriver.ncdEntitlement = e.target.value;
      isNcdChange = true
    } else if (e.target.name === 'sumInsured') {
      if (numValidator(e.target.value)) {
        particularOfMainDriver.sumInsured = e.target.value;
        if (!particularOfMainDriver.sumInsured) {
          addOn.tailgate.checked = false;
          addOn.freezer.checked = false;
          addOn.crane.checked = false;
        }
      }
    }
    this.setState({ cv }, () => {
      this.validationOnCreateDriver();
      if (isOccupationChange) { this.validationMainDriverOccupationAndNationality('occupation'); }
      if (isNationalityChange) { this.validationMainDriverOccupationAndNationality('nationality'); }
      if (isAgeRangeChange) { this.validationMainDriverOccupationAndNationality('ageRange'); }
      if (isNcdChange) { this.calculator() }
    });
  }

  validationMainDriverOccupationAndNationality(type) {
    const cvForm = this.state.cv;
    let occupation = cvForm.particularOfMainDriver.occupation;
    const nationality = cvForm.particularOfMainDriver.nationality;
    const ageRange = cvForm.particularOfMainDriver.ageRange;
    let occupationValid = true;
    let nationalityValid = true;
    let ageRangeValid = true;

    if (!occupation) {
      occupation = '-9999';
    }

    axios.post(`${appUrlPath}/getOccupationReferralCV`, {
      occupation
    })
    .then((res) => {
      if (res.data.referral === true) {
        occupationValid = false;
      }
      if (nationality && nationality !== 'HONG KONG') {
        nationalityValid = false;
      }
      if (ageRange && ageRange === 'Others') {
        ageRangeValid = false;
      }

      if (occupationValid && nationalityValid && ageRangeValid) {
        this.setState({ mainDriverValidSubmit: true });
      } else {
        let errorMsg = '';
        if (!occupationValid && type === 'occupation') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Occupation)';
        } else if (!nationalityValid && type === 'nationality') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Nationality)';
        } else if (!ageRangeValid && type === 'ageRange') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Age)';
        }
        if (errorMsg) {
          this.setState({ mainDriverValidSubmit: false, errorMsg: [errorMsg], showModal: true });
        }
      }
    });
  }

  handleChangeParticularOfAdditionalDriver(id, e) {
    const particularOfAdditionalDriver = this.state.cv.particularOfAdditionalDriver.slice()
    let isOccupationChange = false;
    let isNationalityChange = false;
    let isAgeRangeChange = false;
    if (e.target.name === 'nameFormat') {
      particularOfAdditionalDriver[id].nameFormat = e.target.value;
    } else if (e.target.name === 'surname') {
      particularOfAdditionalDriver[id].surname = e.target.value;
    } else if (e.target.name === 'givenName') {
      particularOfAdditionalDriver[id].givenName = e.target.value;
    } else if (e.target.name === 'drivingExperience') {
      particularOfAdditionalDriver[id].drivingExperience = e.target.value;
    } else if (e.target.name === 'ageRange') {
      particularOfAdditionalDriver[id].ageRange = e.target.value;
      isAgeRangeChange = true;
    } else if (e.target.name === 'maritalStatus') {
      particularOfAdditionalDriver[id].maritalStatus = e.target.value;
    } else if (e.target.name === 'sex') {
      particularOfAdditionalDriver[id].sex = e.target.value;
    } else if (e.target.name === 'noOfClaimsInPast3Years') {
      if (numValidator(e.target.value)) {
        particularOfAdditionalDriver[id].noOfClaimsInPast3Years = Number(e.target.value);
      }
    } else if (e.target.name === 'totalClaimAmountInPast3Years') {
      if (numValidator(e.target.value)) {
        particularOfAdditionalDriver[id].totalClaimAmountInPast3Years = Number(e.target.value);
      }
    } else if (e.target.name === 'occupation') {
      particularOfAdditionalDriver[id].occupation = e.target.value;
      isOccupationChange = true;
    } else if (e.target.name === 'nationality') {
      particularOfAdditionalDriver[id].nationality = e.target.value;
      isNationalityChange = true;
    } else if (e.target.name === 'relationshipWithPolicyholder') {
      particularOfAdditionalDriver[id].relationshipWithPolicyholder = e.target.value;
    }
    this.setState({ cv: { ...this.state.cv, particularOfAdditionalDriver } }, () => {
      this.validationOnCreateDriver()
      if (isOccupationChange) { this.validationAdditionalDriverOccupationAndNationality(particularOfAdditionalDriver[id], 'occupation'); }
      if (isNationalityChange) { this.validationAdditionalDriverOccupationAndNationality(particularOfAdditionalDriver[id], 'nationality'); }
      if (isAgeRangeChange) { this.validationAdditionalDriverOccupationAndNationality(particularOfAdditionalDriver[id], 'ageRange'); }
    })
  }

  validationAdditionalDriverOccupationAndNationality(driver, type) {
    let occupation = driver.occupation;
    const nationality = driver.nationality;
    const ageRange = driver.ageRange
    let occupationValid = true;
    let nationalityValid = true;
    let ageRangeValid = true;

    if (!occupation) {
      occupation = '-9999';
    }

    axios.post(`${appUrlPath}/getOccupationReferralCV`, {
      occupation
    })
    .then((res) => {
      if (res.data.referral) {
        occupationValid = false;
      }
      if (nationality && nationality !== 'HONG KONG') {
        nationalityValid = false;
      }
      if (ageRange && ageRange === 'Others') {
        ageRangeValid = false;
      }

      if (occupationValid && nationalityValid && ageRangeValid) {
        this.setState({ additionalDriverValidSubmit: true });
      } else {
        let errorMsg = '';
        if (!occupationValid && type === 'occupation') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Occupation)';
        } else if (!nationalityValid && type === 'nationality') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Nationality)';
        } else if (!ageRangeValid && type === 'ageRange') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Age)';
        }
        if (errorMsg) {
          this.setState({ additionalDriverValidSubmit: false, errorMsg: [errorMsg], showModal: true });
        }
      }
    });
  }

  handleChangeCoverageInfoPreviousFrom(e) {
    const coverageInfo = { ...this.state.cv.coverageInfo };
    if (e != null && e._isAMomentObject) {
      coverageInfo.coveragePeriodFrom = momentToISOString(e);
      coverageInfo.coveragePeriodTo = quotationMomentAdd1Year(e);
    } else {
      coverageInfo.coveragePeriodTo = null
    }

    this.setState({ cv: { ...this.state.cv, coverageInfo } }, () => {
      this.calculator();
    });
  }

  handleChangeCoverageInfoPreviousTo(e) {
    const coverageInfo = { ...this.state.cv.coverageInfo };
    if (e != null && e._isAMomentObject) {
      coverageInfo.coveragePeriodTo = momentToISOString(e);
    } else {
      coverageInfo.coveragePeriodTo = null
    }
    this.setState({ cv: { ...this.state.cv, coverageInfo } });
  }

  handleSave(event) {
    event.preventDefault();
    if (this.state.typeOfSubmit === 'save') {
      this.setState({ isLoading: true });
      const cv = { ...this.state.cv };
      const coverageFrom = cv.coverageInfo.coveragePeriodFrom;
      if (coverageFrom) {
        const isSameOrAfterToday = momentSetHKTimezone(coverageFrom).isSameOrAfter(moment(), 'day')
        if (!isSameOrAfterToday) {
          this.setState({ isLoading: false, errorMsg: ['Please update coverage period'], showModal: true });
          return
        }
      }
      axios.post(`${appUrlPath}/cvSave`, {
        cv: this.state.cv
      })
      .then((response) => {
        const responseCv = response.data
        const msg = `The quotation number ${this.state.cv.requestInfo.quotationNo} is successfully saved.`;
        this.setState({ isLoading: false, cv: responseCv, errorMsg: [msg], showModal: true });
      })
      .catch(() => {

      });
    } else if (this.state.typeOfSubmit === 'saveQuote') {
      this.setState({ isLoading: true });
      const cv = { ...this.state.cv };
      const coverageFrom = cv.coverageInfo.coveragePeriodFrom;
      if (coverageFrom) {
        const isSameOrAfterToday = momentSetHKTimezone(coverageFrom).isSameOrAfter(moment(), 'day')
        if (!isSameOrAfterToday) {
          this.setState({ isLoading: false, errorMsg: ['Please update coverage period'], showModal: true });
          return
        }
      }
      axios.post(`${appUrlPath}/cvSaveAndQuote`, {
        cv: this.state.cv
      }, { responseType: 'arraybuffer' })
      .then((response) => {
        const msg = `The quotation number ${this.state.cv.requestInfo.quotationNo} is successfully saved.`;
        this.setState({ isLoading: false, errorMsg: [msg], showModal: true });

        const file = new Blob([response.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveOrOpenBlob(file, 'Quotation.pdf');
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
      })
      .catch(() => {

      });
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  handleClick(e) {
    e.preventDefault();
    window.location.assign('/en/motorb2b/home');
  }

  handleChangeAgentCode(e) {
    const requestInfo = { ...this.state.cv.requestInfo };
    const agentCode = e.target.value;
    requestInfo.agentCode = agentCode
    this.setState({ cv: { ...this.state.cv, requestInfo } });
  }

  handleGetAgentName(e) {
    const requestInfo = { ...this.state.cv.requestInfo };
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentNameByAgentCode`, {
      agentCode
    })
    .then((res) => {
      requestInfo.agentName = res.data.agentName
      this.setState({ cv: { ...this.state.cv, requestInfo } });
    });
  }

  optionChange() {
    axios.get(`${appUrlPath}/getModelCV`, {
      params: { 'make': this.state.cv.particularOfVehicle.make }
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {

    });
  }

  handleVehicleGroup() {
    axios.get(`${appUrlPath}/getVehicleGroupCV`, {
      params: {
        'make': this.state.cv.particularOfVehicle.make,
        'model': this.state.cv.particularOfVehicle.model
      }
    })
    .then((res) => {
      const vehicleGroup = res.data.vehicleGroup;
      const particularOfVehicle = { ...this.state.cv.particularOfVehicle };

      particularOfVehicle.vehicleGroup = vehicleGroup
      this.setState({ cv: { ...this.state.cv, particularOfVehicle } }, () => {
        this.calculator();
      });
    })
    .catch(() => {

    });
  }

  handleChangeMainCoverageType(e) {
    const cv = { ...this.state.cv };

    // For coverage type
    if (e.target.value === 'comprehensive') {
      cv.coverageInfo.mainCoverType.comprehensive.checked = true;
      cv.coverageInfo.mainCoverType.thirdParty.checked = false;

      cv.addOn.carDamageInGuangdongProvinceOfChina.disabled = false;
      cv.addOn.tailgate.disabled = false;
      cv.addOn.freezer.disabled = false;
      cv.addOn.crane.disabled = false;

      this.resetComprehensiveOrThirdParty('thirdParty')
    } else if (e.target.value === 'thirdParty') {
      cv.coverageInfo.mainCoverType.thirdParty.checked = true;
      cv.coverageInfo.mainCoverType.comprehensive.checked = false;

      cv.addOn.carDamageInGuangdongProvinceOfChina.checked = false;
      cv.addOn.tailgate.checked = false;
      cv.addOn.freezer.checked = false;
      cv.addOn.crane.checked = false;

      cv.addOn.carDamageInGuangdongProvinceOfChina.disabled = true;
      cv.addOn.tailgate.disabled = true;
      cv.addOn.freezer.disabled = true;
      cv.addOn.crane.disabled = true;

      cv.addOn.carDamageInGuangdongProvinceOfChina.netPremium = 0;
      cv.addOn.carDamageInGuangdongProvinceOfChina.grossPremium = 0;
      cv.addOn.tailgate.netPremium = 0;
      cv.addOn.tailgate.grossPremium = 0;
      cv.addOn.tailgate.tailgateValue = '';
      cv.addOn.freezer.netPremium = 0;
      cv.addOn.freezer.grossPremium = 0;
      cv.addOn.freezer.freezerValue = '';
      cv.addOn.crane.netPremium = 0;
      cv.addOn.crane.grossPremium = 0;
      cv.addOn.crane.craneValue = '';

      this.resetComprehensiveOrThirdParty('comprehensive')
    }

    // For add-on
    if (e.target.name === 'carDamageInGuangdongProvinceOfChina') {
      cv.addOn.carDamageInGuangdongProvinceOfChina.checked = e.target.checked
      if (!cv.addOn.carDamageInGuangdongProvinceOfChina.checked) {
        cv.addOn.carDamageInGuangdongProvinceOfChina.netPremium = 0;
        cv.addOn.carDamageInGuangdongProvinceOfChina.grossPremium = 0;
      }
    } else if (e.target.name === 'thirdPartyLiabilityForTailgateOperation') {
      cv.addOn.thirdPartyLiabilityForTailgateOperation.checked = e.target.checked
      if (!cv.addOn.thirdPartyLiabilityForTailgateOperation.checked) {
        cv.addOn.thirdPartyLiabilityForTailgateOperation.netPremium = 0;
        cv.addOn.thirdPartyLiabilityForTailgateOperation.grossPremium = 0;
      }
    } else if (e.target.name === 'thirdPartyLiabilityForCraneOperation') {
      cv.addOn.thirdPartyLiabilityForCraneOperation.checked = e.target.checked
      if (!cv.addOn.thirdPartyLiabilityForCraneOperation.checked) {
        cv.addOn.thirdPartyLiabilityForCraneOperation.netPremium = 0;
        cv.addOn.thirdPartyLiabilityForCraneOperation.grossPremium = 0;
      }
    } else if (e.target.name === 'thirdPartyPropertyDamageLimit2M') {
      if (cv.particularOfVehicle.tonnage) {
        cv.addOn.thirdPartyPropertyDamageLimit2M.checked = e.target.checked
        if (cv.addOn.thirdPartyPropertyDamageLimit2M.checked) {
          cv.addOn.thirdPartyPropertyDamageLimit5M.checked = false
          cv.addOn.thirdPartyPropertyDamageLimit5M.netPremium = 0
          cv.addOn.thirdPartyPropertyDamageLimit5M.grossPremium = 0
        } else if (!cv.addOn.thirdPartyPropertyDamageLimit2M.checked) {
          cv.addOn.thirdPartyPropertyDamageLimit2M.netPremium = 0
          cv.addOn.thirdPartyPropertyDamageLimit2M.grossPremium = 0
        }
      } else {
        this.setState({ errorMsg: ['Please fill the tonnage'], showModal: true });
      }
    } else if (e.target.name === 'thirdPartyPropertyDamageLimit5M') {
      if (cv.particularOfVehicle.tonnage) {
        cv.addOn.thirdPartyPropertyDamageLimit5M.checked = e.target.checked
        if (cv.addOn.thirdPartyPropertyDamageLimit5M.checked) {
          cv.addOn.thirdPartyPropertyDamageLimit2M.checked = false
          cv.addOn.thirdPartyPropertyDamageLimit2M.netPremium = 0
          cv.addOn.thirdPartyPropertyDamageLimit2M.grossPremium = 0
        } else if (!cv.addOn.thirdPartyPropertyDamageLimit5M.checked) {
          cv.addOn.thirdPartyPropertyDamageLimit5M.netPremium = 0;
          cv.addOn.thirdPartyPropertyDamageLimit5M.grossPremium = 0;
        }
      } else {
        this.setState({ errorMsg: ['Please fill the tonnage'], showModal: true });
      }
    } else if (e.target.name === 'voluntaryExcessForThirdPartyPropertyDamage') {
      cv.addOn.voluntaryExcessForThirdPartyPropertyDamage.checked = e.target.checked
      if (!cv.addOn.voluntaryExcessForThirdPartyPropertyDamage.checked) {
        cv.addOn.voluntaryExcessForThirdPartyPropertyDamage.netPremium = 0;
        cv.addOn.voluntaryExcessForThirdPartyPropertyDamage.grossPremium = 0;
      }
    } else if (e.target.name === 'tailgate') {
      cv.addOn.tailgate.checked = e.target.checked
      if (!cv.addOn.tailgate.checked) {
        cv.addOn.tailgate.netPremium = 0;
        cv.addOn.tailgate.grossPremium = 0;
        cv.addOn.tailgate.tailgateValue = '';
      }
    } else if (e.target.name === 'freezer') {
      cv.addOn.freezer.checked = e.target.checked
      if (!cv.addOn.freezer.checked) {
        cv.addOn.freezer.netPremium = 0
        cv.addOn.freezer.grossPremium = 0
        cv.addOn.freezer.freezerValue = ''
      }
    } else if (e.target.name === 'crane') {
      cv.addOn.crane.checked = e.target.checked
      if (!cv.addOn.crane.checked) {
        cv.addOn.crane.netPremium = 0
        cv.addOn.crane.grossPremium = 0
        cv.addOn.crane.craneValue = ''
      }
    } else if (e.target.id === 'tailgate') {
      if (numValidator(e.target.value)) {
        cv.addOn.tailgate.tailgateValue = e.target.value
      }
    } else if (e.target.id === 'freezer') {
      if (numValidator(e.target.value)) {
        cv.addOn.freezer.freezerValue = e.target.value
      }
    } else if (e.target.id === 'crane') {
      if (numValidator(e.target.value)) {
        cv.addOn.crane.craneValue = e.target.value
      }
    }

    this.setState({ cv }, () => {
      this.calculator();
    });
  }

  handleChangeUnderwritingQuestion(e) {
    const underwritingQuestion = { ...this.state.cv.underwritingQuestion };
    if (e.target.name === 'question1') {
      underwritingQuestion.q1.checked = e.target.value === 'true';
    } else if (e.target.id === 'question1') {
      underwritingQuestion.q1.details = e.target.value
    } else if (e.target.name === 'question2') {
      underwritingQuestion.q2.checked = e.target.value === 'true';
    } else if (e.target.id === 'question2') {
      underwritingQuestion.q2.details = e.target.value
    } else if (e.target.name === 'question3') {
      underwritingQuestion.q3.checked = e.target.value === 'true';
    } else if (e.target.id === 'question3') {
      underwritingQuestion.q3.details = e.target.value
    } else if (e.target.name === 'question4') {
      underwritingQuestion.q4.checked = e.target.value === 'true';
    } else if (e.target.id === 'question4') {
      underwritingQuestion.q4.details = e.target.value
    } else if (e.target.name === 'question5') {
      underwritingQuestion.q5.checked = e.target.value === 'true';
    } else if (e.target.id === 'question5') {
      underwritingQuestion.q5.details = e.target.value
    } else if (e.target.name === 'question6') {
      underwritingQuestion.q6.checked = e.target.value === 'true';
    } else if (e.target.id === 'question6') {
      underwritingQuestion.q6.details = e.target.value
    }
    this.setState({ cv: { ...this.state.cv, underwritingQuestion } }, () => {
      this.validationOnSubmit(true)
    });
  }

  createDriver(e) {
    e.preventDefault();
    this.setState((prevState) => {
      return { count: prevState.count + 1 }
    });
    const tmpDriver = {
      itemId: this.state.count,
      nameFormat: 'surnameGivenName',
      surname: '',
      givenName: '',
      drivingExperience: '',
      ageRange: '',
      maritalStatus: 'Single',
      sex: '',
      noOfClaimsInPast3Years: '',
      totalClaimAmountInPast3Years: '',
      occupation: '',
      nationality: 'HONG KONG',
      relationshipWithPolicyholder: ''
    }
    const particularOfAdditionalDriver = this.state.cv.particularOfAdditionalDriver.slice()
    particularOfAdditionalDriver.push(tmpDriver)
    this.setState({ cv: { ...this.state.cv, particularOfAdditionalDriver } }, () => {
      this.validationOnCreateDriver();
    })
  }

  removeDriver(e) {
    e.preventDefault();
    this.setState((prevState) => {
      return { count: prevState.count - 1 }
    });
    const oldArray = this.state.cv.particularOfAdditionalDriver.slice();
    oldArray.pop();
    const particularOfAdditionalDriver = oldArray;
    this.setState({ cv: { ...this.state.cv, particularOfAdditionalDriver } }, () => {
      this.validationOnCreateDriver()
    })
  }

  calculator() {
    if (this.state.cv.coverageInfo.mainCoverType.comprehensive.checked) {
      this.calculationAmount('comprehensive');
    } else if (this.state.cv.coverageInfo.mainCoverType.thirdParty.checked) {
      this.calculationAmount('thirdParty');
    }
  }

  calculationAmount(type) {
    const cvForm = this.state.cv;
    const vehicleGroup = cvForm.particularOfVehicle.vehicleGroup;
    const yearOfManufacture = cvForm.particularOfVehicle.yearOfManufacture;
    const ncdEntitlement = cvForm.particularOfMainDriver.ncdEntitlement;

    const isValidSubmit = this.validationOnSubmit(true);

    if (vehicleGroup && yearOfManufacture && ncdEntitlement && isValidSubmit) {
      axios.post(`${appUrlPath}/calculateCVQuotation`, {
        cv: cvForm,
        type
      })
      .then((res) => {
        this.setState({ cv: res.data.result });
      })
      .catch(() => {
        this.setState({ errorMsg: ['Calculation Error.'], showModal: true });
      });
    } else {
      this.resetComprehensiveOrThirdParty('comprehensive')
      this.resetComprehensiveOrThirdParty('thirdParty')
    }
  }

  resetComprehensiveOrThirdParty(type) {
    const mainCoverType = { ...this.state.cv.coverageInfo.mainCoverType };
    if (type === 'comprehensive') {
      mainCoverType.comprehensive.grossPremium = 0;
      mainCoverType.comprehensive.netPremium = 0;
    } else if (type === 'thirdParty') {
      mainCoverType.thirdParty.grossPremium = 0;
      mainCoverType.thirdParty.netPremium = 0;
    }

    const cv = { ...this.state.cv };

    cv.grossPremium = 0
    cv.netPremium = 0
    cv.mib = 0
    cv.levy = 0
    cv.premiumPayable = 0

    this.setState({ cv: { ...this.state.cv, mainCoverType } });
    this.setState({ cv });
  }

  validationOnCreateDriver() {
    let isValidCreateDriver = false;
    const particularOfMainDriver = this.state.cv.particularOfMainDriver;
    const particularOfAdditionalDriver = this.state.cv.particularOfAdditionalDriver;
    if (particularOfMainDriver.drivingExperience && particularOfMainDriver.ageRange
        && particularOfMainDriver.noOfClaimsInPast3Years.toString() && particularOfMainDriver.totalClaimAmountInPast3Years.toString()
        && particularOfMainDriver.occupation && particularOfMainDriver.sex
        && particularOfMainDriver.nationality) {
      isValidCreateDriver = true
    } else {
      isValidCreateDriver = false
      this.setState({ isValidCreateDriver })
      return;
    }

    if (particularOfAdditionalDriver.length > 0) {
      for (let i = 0; i < particularOfAdditionalDriver.length; i++) {
        const driver = particularOfAdditionalDriver[i]
        if (driver.drivingExperience && driver.ageRange
            && driver.noOfClaimsInPast3Years.toString() && driver.totalClaimAmountInPast3Years.toString()
            && driver.occupation && driver.sex
            && driver.nationality) {
          isValidCreateDriver = true;
        } else {
          isValidCreateDriver = false;
          break;
        }
      }
    }
    this.setState({ isValidCreateDriver })
  }

  validationOccupation() {
    const cvForm = this.state.cv;
    const occupation = cvForm.particularOfVehicle.busType;
    if (occupation) {
      axios.post(`${appUrlPath}/getOccupationReferralCV`, {
        occupation
      })
      .then((res) => {
        if (res.data.referral) {
          const errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Occupation)';
          this.setState({ additionalDriverValidSubmit: false, errorMsg: [errorMsg], showModal: true });
        } else {
          this.setState({ validSubmit: true });
        }
      });
    }
  }

  validationOnSubmit(showAlert) {
    const type = ['noOfClaims', 'totalClaimAmount', 'underwritingQuestion', 'vehicleRegNo', 'seatingCap', 'yearOfManufacture', 'vehicleGroup', 'tailgate', 'freezer', 'crane', 'ageRange', 'drivingExperience', 'sumInsured', 'tonnage']

    let validSubmit = this.state.validSubmit;
    const cvForm = this.state.cv;
    const comprehensive = cvForm.coverageInfo.mainCoverType.comprehensive;
    const thirdParty = cvForm.coverageInfo.mainCoverType.thirdParty;

    const tailgate = cvForm.addOn.tailgate
    const freezer = cvForm.addOn.freezer
    const crane = cvForm.addOn.crane

    const errorMsg = [];

    let isValid = true;
    let check = true;

    for (let i = 0; i < type.length && check; i++) {
      const typeValue = type[i]

      if (typeValue === 'seatingCap') {
        const seatingCap = cvForm.particularOfVehicle.seatingCap;
        if (check) {
          if (seatingCap > 7) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive.\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
          }
        }
      }

      if (typeValue === 'tonnage') {
        const tonnage = cvForm.particularOfVehicle.tonnage;
        if (check) {
          if (tonnage > 24) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive.\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
          }
        }
      }

      if (typeValue === 'noOfClaims') {
        const mainDriverNoOfClaims = cvForm.particularOfMainDriver.noOfClaimsInPast3Years;
        const mainDriverTotalClaimAmount = cvForm.particularOfMainDriver.totalClaimAmountInPast3Years;
        if (cvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < cvForm.particularOfAdditionalDriver.length && check; j++) {
            const noOfClaims = cvForm.particularOfAdditionalDriver[j].noOfClaimsInPast3Years;
            const totalClaimAmount = cvForm.particularOfAdditionalDriver[j].totalClaimAmountInPast3Years;
            if (noOfClaims !== '' && noOfClaims > 0) {
              errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (No of claims - Additional Driver)\n')
              validSubmit = false;
              isValid = false;
              check = false;
            } else if (totalClaimAmount !== '' && totalClaimAmount > 0 &&
                noOfClaims === 0) {
              errorMsg.push('Inconsistent claim number and claim amount\n')
              validSubmit = false;
              isValid = false;
              check = false;
            } else {
              validSubmit = true;
              isValid = true;
            }
          }
        }

        if (check) {
          if (mainDriverNoOfClaims !== '' && mainDriverNoOfClaims > 0) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (No of claims - Main Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (mainDriverTotalClaimAmount !== '' && mainDriverTotalClaimAmount > 0 &&
              mainDriverNoOfClaims === 0) {
            errorMsg.push('Inconsistent claim number and claim amount\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'totalClaimAmount') {
        const mainDriverNoOfClaims = cvForm.particularOfMainDriver.noOfClaimsInPast3Years;
        const mainDriverTotalClaimAmount = cvForm.particularOfMainDriver.totalClaimAmountInPast3Years;
        if (cvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < cvForm.particularOfAdditionalDriver.length && check; j++) {
            const noOfClaims = cvForm.particularOfAdditionalDriver[j].noOfClaimsInPast3Years;
            const totalClaimAmount = cvForm.particularOfAdditionalDriver[j].totalClaimAmountInPast3Years;
            if (totalClaimAmount !== '' && totalClaimAmount > 0 &&
                noOfClaims === 0) {
              errorMsg.push('Inconsistent claim number and claim amount\n')
              validSubmit = false;
              isValid = false;
              check = false;
            } else {
              validSubmit = true;
              isValid = true;
            }
          }
        }

        if (check) {
          if (mainDriverTotalClaimAmount !== '' && mainDriverTotalClaimAmount > 0 &&
              mainDriverNoOfClaims === 0) {
            errorMsg.push('Inconsistent claim number and claim amount\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'drivingExperience') {
        const mainDriverDrivingExperience = cvForm.particularOfMainDriver.drivingExperience;
        const addDriverDrivingExperienceArray = []
        if (cvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < cvForm.particularOfAdditionalDriver.length; j++) {
            addDriverDrivingExperienceArray.push(cvForm.particularOfAdditionalDriver[j].drivingExperience)
          }
        }

        for (let j = 0; j < addDriverDrivingExperienceArray.length && check; j++) {
          if (addDriverDrivingExperienceArray[j] !== '' && addDriverDrivingExperienceArray[j] < 2) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Driving Experience - Additional Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }

        if (check) {
          if (mainDriverDrivingExperience !== '' && mainDriverDrivingExperience < 2) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Driving Experience - Main Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'underwritingQuestion') {
        const q2 = this.state.cv.underwritingQuestion.q2;
        const q3 = this.state.cv.underwritingQuestion.q3;
        const q4 = this.state.cv.underwritingQuestion.q4;
        const q5 = this.state.cv.underwritingQuestion.q5;

        if (check) {
          if (q2.checked || q3.checked || q4.checked || q5.checked) {
            errorMsg.push('Please contact us for referral case.\n')
            validSubmit = false
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'vehicleGroup') {
        const vehicleGroup = cvForm.particularOfVehicle.vehicleGroup
        if (check) {
          if (vehicleGroup === '30' || vehicleGroup === '98' || vehicleGroup === '99') {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Make and Model)\n');
            validSubmit = false;
            isValid = false
            check = false;
          } else {
            validSubmit = true;
            isValid = true
          }
        }
      }

      if (typeValue === 'yearOfManufacture') {
        if (check) {
          if (comprehensive.checked) {
            const yearOfManufacture = cvForm.particularOfVehicle.yearOfManufacture;
            if (yearOfManufacture) {
              const vehicleAge = moment(cvForm.coverageInfo.coveragePeriodFrom).year() - yearOfManufacture;
              if (vehicleAge > 20) {
                errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Year of Manufacture)\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else if (vehicleAge < 0) {
                errorMsg.push('Vehicle age (inception year - manufacture year) must >= 0.\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else {
                validSubmit = true;
                isValid = true;
              }
            }
          } else if (thirdParty.checked) {
            const yearOfManufacture = cvForm.particularOfVehicle.yearOfManufacture;
            if (yearOfManufacture) {
              const vehicleAge = moment(cvForm.coverageInfo.coveragePeriodFrom).year() - yearOfManufacture;
              if (vehicleAge > 25) {
                errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Year of Manufacture)\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else if (vehicleAge < 0) {
                errorMsg.push('Vehicle age (inception year - manufacture year) must >= 0.\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else {
                validSubmit = true;
                isValid = true;
              }
            }
          }
        }
      }

      if (typeValue === 'vehicleRegNo') {
        const vehicleRegNo = cvForm.particularOfVehicle.vehicleRegNo;
        if (check) {
          if (vehicleRegNo.indexOf('I') !== -1 ||
              vehicleRegNo.indexOf('O') !== -1 ||
              vehicleRegNo.indexOf('Q') !== -1 ||
              vehicleRegNo.indexOf('i') !== -1 ||
              vehicleRegNo.indexOf('o') !== -1 ||
              vehicleRegNo.indexOf('q') !== -1) {
            errorMsg.push('Invalid registration mark\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
          }
        }
      }

      if (typeValue === 'tailgate') {
        if (check) {
          if (tailgate.checked && !tailgate.tailgateValue) {
            errorMsg.push('Please fill the tailgate value.\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (tailgate.tailgateValue < 0) {
            errorMsg.push('Tailgate cannot be negative\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (tailgate.tailgateValue > 40000) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Tailgate)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'freezer') {
        if (check) {
          if (freezer.checked && !freezer.freezerValue) {
            errorMsg.push('Please fill the freezer value.\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (freezer.freezerValue < 0) {
            errorMsg.push('Freezer cannot be negative\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (freezer.freezerValue > 200000) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Freezer)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'crane') {
        if (check) {
          if (crane.checked && !crane.craneValue) {
            errorMsg.push('Please fill the crane value.\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (crane.craneValue < 0) {
            errorMsg.push('Crane cannot be negative\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (crane.craneValue > 150000) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Crane)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'ageRange') {
        const mainDriverAgeRange = cvForm.particularOfMainDriver.ageRange;
        const addDriverAgeRangeArray = []
        if (cvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < cvForm.particularOfAdditionalDriver.length; j++) {
            addDriverAgeRangeArray.push(cvForm.particularOfAdditionalDriver[j].ageRange)
          }
        }

        for (let j = 0; j < addDriverAgeRangeArray.length && check; j++) {
          if (addDriverAgeRangeArray[j] === 'Others') {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Age - Additional Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }

        if (check) {
          if (mainDriverAgeRange === 'Others') {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Age - Main Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'sumInsured') {
        const sumInsured = cvForm.particularOfMainDriver.sumInsured;
        if (check) {
          if (sumInsured < 0) {
            errorMsg.push('Invalid Sum Insured\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
          }
        }
      }
    }

    if (showAlert && errorMsg.length > 0) {
      this.setState({ errorMsg, showModal: true });
    }
    this.setState({ validSubmit });
    return isValid;
  }

  handleSubmitType(type) {
    if (type === 'save') {
      this.setState({
        typeOfSubmit: 'save'
      });
    } else if (type === 'saveQuote') {
      this.setState({
        typeOfSubmit: 'saveQuote'
      });
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (

      <div>
      {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              this.state.errorMsg.map((errorMsg) => {
                return <div>{errorMsg}</div>
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        <h3 className="ebaoUtil__HeaderTwo">New Quotation - SmartDrive Commercial Vehicle</h3>
        <ul className="ebaoUtil__Remarks">
          <li>* Mandatory for New Quotation</li>
        </ul>
        <Form horizontal onSubmit={this.handleSave}>
           <div className="ebaoUtil__Form-100">
              <RequestInfo
                requestInfo={this.state.cv.requestInfo}
                handleChangeRequestInfo={this.handleChangeRequestInfo}
                handleGetAgentName={this.handleGetAgentName}
                handleChangeAgentCode={this.handleChangeAgentCode}
                role={this.state.role}
                insuredNameRequired
              />
              <CustomerContactInfo
                custContactInfo={this.state.cv.custContactInfo}
                handleChangeCustContactInfo={this.handleChangeCustContactInfo}
              />
              <ParticularOfVehicle
                particularOfVehicle={this.state.cv.particularOfVehicle}
                handleChangeParticularOfVehicle={this.handleChangeParticularOfVehicle}
                option={this.state.option}
                calculation={this.calculator}
                validation={this.validationOnSubmit}
              />
              <ParticularOfMainDriver
                particularOfMainDriver={this.state.cv.particularOfMainDriver}
                handleChangeParticularOfAdditionalDriver={this.handleChangeParticularOfAdditionalDriver}
                handleChangeParticularOfMainDriver={this.handleChangeParticularOfMainDriver}
                calculation={this.calculator}
                particularOfAdditionalDriver={this.state.cv.particularOfAdditionalDriver}
                createDriver={this.createDriver}
                removeDriver={this.removeDriver}
                count={this.state.count}
                isValidCreateDriver={this.state.isValidCreateDriver}
                validation={this.validationOnSubmit}
              />

              <NcdEntitlementSumInsuredSection
                particularOfMainDriver={this.state.cv.particularOfMainDriver}
                handleChangeParticularOfMainDriver={this.handleChangeParticularOfMainDriver}
                validation={this.validationOnSubmit}
              />
              <CoverageInformation
                coverageInfo={this.state.cv.coverageInfo}
                handleChangeCoverageInfoPreviousFrom={this.handleChangeCoverageInfoPreviousFrom}
                handleChangeCoverageInfoPreviousTo={this.handleChangeCoverageInfoPreviousTo}
              />
              <CoverageTypeInfo
                mainCoverType={this.state.cv.coverageInfo.mainCoverType}
                handleChangeMainCoverageType={this.handleChangeMainCoverageType}
                addOn={this.state.cv.addOn}
              />
              <UnderwritingQuestion
                underwritingQuestion={this.state.cv.underwritingQuestion}
                handleChangeUnderwritingQuestion={this.handleChangeUnderwritingQuestion}
              />
              <QuoteSummary
                grossPremium={this.state.cv.grossPremium}
                netPremium={this.state.cv.netPremium}
                mib={this.state.cv.mib}
                levy={this.state.cv.levy}
                premiumPayable={this.state.cv.premiumPayable}
              />
              <FormGroup controlId="buttonGroup">
                <div className="ebaoUtil__ButtonGroup-70">
                  {(this.state.validSubmit && this.state.additionalDriverValidSubmit && this.state.mainDriverValidSubmit) ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('save')} id="save">Save</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('save')} id="save" disabled>Save</button>
                  }{' '}
                  {(this.state.validSubmit && this.state.additionalDriverValidSubmit && this.state.mainDriverValidSubmit) ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('saveQuote')} id="saveQuote">Save & Quote</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('saveQuote')} id="saveQuote" disabled>Save & Quote</button>
                  }{' '}

                  <button className="btn btn-axa" onClick={this.handleClick} type="button">Exit</button>
                </div>
              </FormGroup>
           </div>
           </Form>
      </div>

    )
  }
}

CVForm.propTypes = {
  location: {
    state: {
      isAgree: PropTypes.bool
    }
  }
};

export default CVForm;



// WEBPACK FOOTER //
// ./src/app/pages/CVForm.js